import { render, staticRenderFns } from "./global-errors.vue?vue&type=template&id=76a1c544"
import script from "./global-errors.vue?vue&type=script&lang=js"
export * from "./global-errors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports